import EthereumTransaction from 'decentralized/transactions/EthereumTransaction.js';
import {
    ListEdited,
    ListDeleted
} from 'decentralized/EthereumEvents.js';
import ExploreListsContract from 'decentralized/contracts/ExploreListsContract.js';
import BackendQuery from 'decentralized/BackendQuery.js';
import {web3} from 'decentralized/web3.js';
import {ipfsHashToBytes32} from 'utils/ipfsHash.js';
import {EXPLORE_LISTS} from 'decentralized/transactions/contracts.js';

const CONTRACT_ADDRESS = new ExploreListsContract().contractAddress;

const NULL_BYTES32 = web3.utils.padLeft('0x0', 64);

const QUERY = () => new BackendQuery(CONTRACT_ADDRESS);

export const deleteList = async (content) => {
    await new EthereumTransaction(
        EXPLORE_LISTS,
        'deleteList',
        [
            ipfsHashToBytes32(content),
        ])
        .execute();
};

export const publishBulk = async (newContents, oldContents, titles, guildIds) => {
    await new EthereumTransaction(
        EXPLORE_LISTS,
        'bulkEdit',
        [
            newContents.map(hash => ipfsHashToBytes32(hash)),
            oldContents.map(hash => hash ? ipfsHashToBytes32(hash) : NULL_BYTES32),
            titles.map(title => web3.utils.fromAscii(title)),
            guildIds
        ])
        .execute();
};

export const getLists = async () => {
    let query = QUERY()
        .from(ListEdited)
        .select("newContent")
        .select("previousContent")
        .select("title");

    return await filterDeletedLists(getLatestLists(await query.executeQuery()));
};

const filterDeletedLists = async (lists) => {
    let ids = lists.map(x => x.newContent);

    let query = QUERY()
        .from(ListDeleted)
        .select("contentHash");

    let deleted = new Set(
        (await query.executeQuery())
            .map(x => x.contentHash));

    return lists.filter(
        x => /*!deleted.has(x.previousContent) && */ !deleted.has(x.newContent));
};

const getLatestLists = (lists) => {
    let newToPrev = {};
    for (let list of lists) {
        if (list.previousContent && list.previousContent !== list.newContent) {
            newToPrev[list.newContent] = list.previousContent;
        }
    }

    let rootToLists = {};
    for (let list of lists) {
        let root = getRoot(list.newContent, newToPrev);
        if (! (root in rootToLists)) {
            rootToLists[root] = [];
        }
        rootToLists[root].push(list);
    }

    let latest = [];
    for (let root in rootToLists) {
        rootToLists[root].sort((a,b) => b.blockNumber - a.blockNumber);
        latest.push(rootToLists[root][0]);
    }
    return latest;
};

const getRoot = (hash, newToPrev) => {
    let prev = newToPrev[hash];
    if (prev === undefined) {
        return hash;
    }
    return getRoot(prev, newToPrev);
};
